import { Link } from "react-router-dom";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { OperatorContact } from "@/components/legal/OperatorContact";
import { CONTACT, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function ContactPage() {
  return (
    <LegalLayout
      title="Contact Us"
      subtitle={`Reach the ${OPERATOR.product} team.`}
    >
      <LegalSection title="Operator">
        <OperatorContact />
      </LegalSection>

      <LegalSection title="Email">
        <LegalUl
          items={[
            <>
              <strong>Support & reports:</strong>{" "}
              <a href={`mailto:${CONTACT.support}`} className={tw.link}>
                {CONTACT.support}
              </a>
              ,{" "}
              <a href={`mailto:${CONTACT.help}`} className={tw.link}>
                {CONTACT.help}
              </a>
            </>,
            <>
              <strong>Admin & partnerships:</strong>{" "}
              <a href={`mailto:${CONTACT.admin}`} className={tw.link}>
                {CONTACT.admin}
              </a>
            </>,
            <>
              <strong>Automated mail:</strong>{" "}
              <a href={`mailto:${CONTACT.noreply}`} className={tw.link}>
                {CONTACT.noreply}
              </a>{" "}
              (no replies monitored)
            </>,
          ]}
        />
      </LegalSection>

      <LegalSection title="Phone">
        <LegalUl
          items={CONTACT.phones.map((phone) => (
            <a
              key={phone}
              href={`tel:${phone.replace(/\s/g, "")}`}
              className={tw.link}
            >
              {phone}
            </a>
          ))}
        />
        <LegalP>Business hours: Monday–Saturday, 10:00–18:00 IST (India Standard Time).</LegalP>
      </LegalSection>

      <LegalSection title="What to include">
        <LegalUl
          items={[
            "Your Daywia username or registered email.",
            "Device model and app version (Settings → About, or from Play Store).",
            "Steps to reproduce bugs, with screenshots if possible.",
            "For abuse reports: links or usernames involved and why the content violates our Guidelines.",
          ]}
        />
      </LegalSection>

      <LegalSection title="Response time">
        <LegalP>
          We typically respond to support and abuse reports within <strong>one business day</strong>.
          Privacy and legal requests under the DPDP Act within <strong>30 days</strong>.
        </LegalP>
      </LegalSection>

      <LegalSection title="In-app">
        <LegalP>
          Signed-in users can also use Settings → Report an issue or Settings → FAQ. Account
          deletion: Settings → FAQ → Delete account, or see{" "}
          <Link to="/data-deletion" className={tw.link}>
            Data deletion
          </Link>
          .
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
